import { observable } from 'mobx';
import { useEffect } from 'react';
import { jumpPage } from '@src/utils/common-util';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { MECHA_INFO } from './config';

class page5Store {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  // 是否激活
  @observable isActive = false;
  @observable mechaList = [];
  @observable activeIndex = 0;

  mechaUnitSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      allowTouchMove: MECHA_INFO.length > 1
    },
    onSlideChange: realIndex => {
      this.activeIndex = realIndex;
      this.indicatorSwiperStore.onChange(this.activeIndex - 1);
    }
  });

  indicatorSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      initialSlide: this.activeIndex,
      direction: 'horizontal',
      spaceBetween: 5,
      slidesPerView: 4,
      slideToClickedSlide: true,
      centerInsufficientSlides: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      allowTouchMove: false
    }
  });

  toSlideWithIndex = index => {
    this.activeIndex = index;
    this.mechaUnitSwiper.onChange(index);
  };

  goPrev = () => {
    if (this.activeIndex === 0) {
      this.toSlideWithIndex(MECHA_INFO.length - 1);
      return;
    }
    this.toSlideWithIndex(this.activeIndex - 1);
  };

  goNext = () => {
    if (this.activeIndex === MECHA_INFO.length - 1) {
      this.toSlideWithIndex(0);
      return;
    }
    this.toSlideWithIndex(this.activeIndex + 1);
  };

  gounit(id) {
    if (!IS_DEV_ENV) {
      const url = 'mecha-unit.html';
      jumpPage(url, `?id=${id}`);
    } else {
      this.mainStore?.redirect(`/mecha-unit?id=${id}`);
    }
  }

  use() {
    const funlinkData = useLayerData('mechaUnitData');
    useEffect(
      () => {
        if (funlinkData) {
          this.mechaList = funlinkData?.mechaList || [];
        }
      },
      [funlinkData]
    );
  }
}

export default page5Store;
